import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CitiShopPropsService } from '../../utility/citi-shop-props.service';

@Component({
  selector: 'app-citi-shop-suspend-dialog',
  templateUrl: './citi-shop-suspend-dialog.component.html',
  styleUrls: ['./citi-shop-suspend-dialog.component.scss'],
  standalone: false,
  host: { 'class': 'cbolui-cds' }
})
export class CitiShopSuspendDialogComponent implements OnInit, OnDestroy {
  @Input() suspendDialogParams;
  showDialog = false;
  citiLogoUrl = '';
  dialogRightImgUrl = '';

  constructor(public csp: CitiShopPropsService) {}

  ngOnInit() {
    this.showDialog =  this.suspendDialogParams?.isDialogEnable
    this.citiLogoUrl = this.csp.imagePrefix() + this.suspendDialogParams?.citiLogoUrl;
    this.dialogRightImgUrl = this.csp.imagePrefix() + this.suspendDialogParams?.dialogRightImageUrl;
  }

  closeSuspendDialog() {
    this.showDialog = false;
  }
  ngOnDestroy(): void{
    this.closeSuspendDialog();
  }
}
